import "./index.scss"
import DeliveryBoy from 'assets/delivery-boy.png'

interface Props {
}

export function QuickDelivery(props: Props) {
    return (
        <div className="bg">
            <div className="max-width p-x">
                <div className="bg-main mp-2">
                    <div className="quickDelivery mp-2">
                        <div className="quickDelivery-left">
                            <div className="quickDelivery-left__title">
                                organic products and food
                            </div>
                            <div className="quickDelivery-left__top">
                                quick delivery to <span className="text-main">your home</span>
                            </div>
                            <p className="quickDelivery-left__body">
                                There are many products you will find our shop, Choose your daily necessary product from our KachaBazar shop and get some special offer. See Our latest discounted products from here and get a special discount.
                                <br />
                                <a href="#downloadApp" className="downloadApp">download app</a>
                            </p>
                        </div>
                        <div className="quickDelivery-right desktop">
                            <img src={DeliveryBoy} alt="Deivery Man" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
